import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { IcdCodeType } from '../../../../core/api/mhsConfigurationApiClient';
import { IProcedureCodePickerData } from '../../dto/procedure-code-picker-data';
import { ProceduresService } from '../../services/procedures-service';

@Component({
  selector: 'app-procedure-code-picker',
  imports: [NzSelectModule, NzSpinModule, NzGridModule, FormsModule],
  templateUrl: './procedure-code-picker.html',
  styleUrl: './procedure-code-picker.scss',
})
export class ProcedureCodePicker {
  readonly procedureService = inject(ProceduresService);
  readonly modalRef = inject(NzModalRef);
  readonly modalData = inject<IProcedureCodePickerData>(NZ_MODAL_DATA);
  readonly isLoading = signal(false);
  readonly codes = signal<Array<{ label: string; value: string }>>([]);
  readonly searchPhrase = signal('');
  readonly top = signal(10);
  readonly phrase = signal('');
  readonly title = signal<string | undefined>(undefined);
  selectedCode: string | null = null;

  onSearch(value: string): void {
    this.searchPhrase.set(value);
    this.top.set(10);

    this.fetch();
  }
  loadMoreCodes() {
    if (this.isLoading()) {
      return;
    }

    this.top.set(this.top() + 10);
    this.fetch();
  }
  fetch() {
    if (this.searchPhrase() === '') {
      this.codes.set([]);
      return;
    }
    this.isLoading.set(true);
    this.procedureService
      .queryCode(this.mapIcdCodeType(this.modalData.codeType), this.searchPhrase(), this.top())
      .subscribe((data) => {
        this.isLoading.set(false);
        this.codes.set(
          data.map((item) => ({
            label: `[${item.code!}] ${item.name!}`,
            value: item.code!,
          })),
        );
      });
  }
  mapIcdCodeType(code: string): IcdCodeType {
    switch (code.toLowerCase()) {
      case 'icd10':
        return IcdCodeType.Icd10;
      case 'icd9':
        return IcdCodeType.Icd9;
      case 'icd8':
        return IcdCodeType.Icd8;
      case 'icd7':
        return IcdCodeType.Icd7;
      default:
        throw new Error(`Unknown ICD code type: ${code}`);
    }
  }
}
